// Helpers to export/import Larkwell agents & skills as human-friendly markdown.

const esc = (v) => (v === undefined || v === null ? '' : String(v));

export function agentToMarkdown(a) {
  const lines = [];
  lines.push(`# Agent: ${esc(a.name) || 'Untitled agent'}`);
  if (a.description) lines.push(`- description: ${esc(a.description)}`);
  if (a.avatar) lines.push(`- avatar: ${esc(a.avatar)}`);
  if (a.color) lines.push(`- color: ${esc(a.color)}`);
  lines.push(`- provider: ${esc(a.provider) || 'openai'}`);
  lines.push(`- model: ${esc(a.model) || 'gpt-5.4'}`);
  if (a.voice) lines.push(`- voice: ${esc(a.voice)}`);
  if (a.voice_rate && a.voice_rate !== 1) lines.push(`- voice_rate: ${esc(a.voice_rate)}`);
  lines.push('');
  lines.push('## Persona');
  lines.push(esc(a.persona) || 'You are a helpful assistant.');
  lines.push('');
  return lines.join('\n');
}

export function skillToMarkdown(s) {
  const lines = [];
  lines.push(`# Skill: ${esc(s.name) || 'Untitled skill'}`);
  if (s.description) lines.push(`- description: ${esc(s.description)}`);
  lines.push(`- kind: ${esc(s.kind) || 'webhook'}`);
  const cfg = s.config || {};
  const inlineKeys = Object.keys(cfg).filter((k) => k !== 'template');
  inlineKeys.forEach((k) => lines.push(`- config.${k}: ${esc(cfg[k])}`));
  if (cfg.template) {
    lines.push('');
    lines.push('## Template');
    lines.push(esc(cfg.template));
  }
  lines.push('');
  return lines.join('\n');
}

export const TEMPLATE_MARKDOWN = `# Agent: Focus Coach
- description: Keeps you on task with tiny steps
- avatar: 🧭
- color: #e8590c
- provider: openai
- model: gpt-5.4
- voice: Samantha
- voice_rate: 1.0

## Persona
You are a warm ADHD focus coach. Reduce overwhelm, suggest one tiny 2-minute
step, use concrete time language, and celebrate small wins. Never shame missed plans.

# Skill: Send Slack Message
- description: Posts a message to a Slack channel
- kind: webhook
- config.url: https://hooks.slack.com/services/XXXX
- config.method: POST

# Skill: Weekly Review
- description: A reusable prompt playbook
- kind: playbook

## Template
When the user asks for a weekly review, ask about wins, blockers, and next
week's single most important task. Keep it short and encouraging.
`;

export function downloadTextFile(filename, text) {
  const blob = new Blob([text], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const slug = (s) => (s || 'export').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export function exportAgent(a) {
  downloadTextFile(`agent-${slug(a.name)}.md`, agentToMarkdown(a));
}
export function exportSkill(s) {
  downloadTextFile(`skill-${slug(s.name)}.md`, skillToMarkdown(s));
}
